/* hp26 v5j (draft) – card quantity stepper; value is posted with the product form. */
(() => {
  const clamp = (el) => {
    const min = Number(el.min) || 1;
    const max = Number(el.max) || 99;
    let v = parseInt(el.value, 10);
    if (Number.isNaN(v)) v = min;
    el.value = Math.min(max, Math.max(min, v));
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-hp26-qty] [data-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('.hp26-qty__in');
    input.value = (parseInt(input.value, 10) || 1) + Number(b.dataset.step);
    clamp(input);
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('.hp26-qty__in')) clamp(e.target);
  });
  const reset = (e) => {
    const input = e.target.querySelector && e.target.querySelector('.hp26-qty__in');
    if (input) input.value = 1;
  };
  document.addEventListener('on:cart:add', reset);
  document.addEventListener('on:line-item:change', reset);
})();
